import AddProductToInventory from "../views/Catalog/addProductToInventory";
import ProductPreview from "../views/Catalog/addProductToInventory/ProductPreview";
import RequestNewProduct from "../views/Catalog/requestNewProduct/requestNewProduct";
import TrackApprovalRequests from "../views/Catalog/trackApprovalRequests";
import SellerVerification from "../views/Catalog/trackApprovalRequests/SellerVerification";
import DashBoard from "../views/DashBoard";
import Inventory from "../views/Inventory";
import EditInventory from "../views/Inventory/EditInventory";
import Login from "../views/Login";
import MyProfile from "../views/myProfile";
import OrderList from "../views/Orders";
import { SellerOrderHistory } from "../views/Orders/OrderHistory";
import ReportsAnalytics from "../views/reportsAnalytics";
import Return from "../views/Return";
import { ReturnDetails } from "../views/Return/Returndetail";
import Reviews from "../views/Reviews";
import { Settements } from "../views/Settlements";
import StoreSetting from "../views/storeSetting";

export const routes = [
  {
    path: "/signIn",
    export: true,
    name: "SignIn",
    component: Login,
  },
  {
    path: "/storeSetting",
    export: true,
    name: "Store Setting",
    component: StoreSetting,
    superAdminAllowed: false,
  },
  {
    path: "/myProfile",
    export: true,
    name: "My Profile",
    component: MyProfile,
    superAdminAllowed: false,
  },

  {
    path: "/dashBoard",
    export: true,
    name: "DashBoard",
    component: DashBoard,
    superAdminAllowed: false,
  },
  {
    path: "/reviewsList",
    export: true,
    name: "Reviews List",
    component: Reviews,
    superAdminAllowed: false,
  },
  {
    path: "/Return",
    export: true,
    name: "Return",
    component: Return,
    superAdminAllowed: false,
  },
  {
    path: "/reportsAnalytics",
    export: true,
    name: "Reports Analytics",
    component: ReportsAnalytics,
    superAdminAllowed: false,
  },

  {
    path: "/Orders",
    export: true,
    name: "Orders",
    component: OrderList,
    superAdminAllowed: true,
  },
  {
    path: "/orderHistory/:id",
    export: true,
    name: "Order History",
    component: SellerOrderHistory,
    superAdminAllowed: true,
  },

  {
    path: "/Inventory",
    export: true,
    name: "Inventory",
    component: Inventory,
    superAdminAllowed: false,
  },

  {
    path: "/editInventory/:id/:base",
    export: true,
    name: "Edit Inventory",
    component: EditInventory,
    superAdminAllowed: false,
  },

  {
    path: "/addProductToInventory",
    export: true,
    name: "Add Product To Inventory",
    component: AddProductToInventory,
    superAdminAllowed: false,
  },
  {
    path: "/productPreview/:id/:base",
    export: true,
    name: "Product Preview",
    component: ProductPreview,
    superAdminAllowed: false,
  },
  {
    path: "/requestNewProduct",
    export: true,
    name: "Request New Product",
    component: RequestNewProduct,
    superAdminAllowed: false,
  },
  {
    path: "/trackApprovalRequests",
    export: true,
    name: "Track Approval Requests",
    component: TrackApprovalRequests,
    superAdminAllowed: false,
  },
  {
    path: "/sellerVerificationRequest/:id",
    export: true,
    name: "Seller Verification Request",
    component: SellerVerification,
    superAdminAllowed: false,
  },

  {
    path: "/orderReturn/:id",
    export: true,
    name: "Order Return",
    component: ReturnDetails,
    superAdminAllowed: false,
  },

  {
    path: "/settlements",
    export: true,
    name: "Settlements",
    component: Settements,
    superAdminAllowed: false,
  },
];
